import type { ExcQuotemediaV1Sp500ListKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const QUOTEMEDIA_SP500_LIST_BASE_PATH = getResolvedPath('/clearing/vendor/quote-media/sp-500');

export const getQuotemediaSp500ListPath: EntityPathBuilder<ExcQuotemediaV1Sp500ListKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return QUOTEMEDIA_SP500_LIST_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.quarter) {
        return undefined;
      }

      return getResolvedPath(`${QUOTEMEDIA_SP500_LIST_BASE_PATH}/$quarter`, context.keys);
    }
  }
};

export function getQuotemediaSp500ListDetailPath(quarter: string | undefined) {
  if (!quarter) {
    return undefined;
  }

  return getQuotemediaSp500ListPath({ kind: 'detail', keys: { quarter } });
}
